import { render, staticRenderFns } from "./UpdateMember.vue?vue&type=template&id=1d5e5ef7&"
import script from "./UpdateMember.vue?vue&type=script&lang=js&"
export * from "./UpdateMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports